import { defineStore } from "pinia"

const quickLanguageStore = defineStore('quickLanguageStore', {
  state: () => ({
    contentList: [],  // 搜索结果列表
    show: false,      // 快捷语弹窗显示控制
    total: 0,          // 搜索结果总数
    currentText: '',    // 当前输入的文本
    quickLanguageText: '' // 选择的快捷语内容
  }),
  actions: {
    changeInput(currentText:string, contentList: any, total: number) {
      this.currentText = currentText
      this.contentList = contentList
      this.total = total
      this.show = true
    },
    setQuickLanguageText(text: string){
      this.quickLanguageText = text
    },

    // 隐藏快捷语弹窗
    hide(){
      this.show = false
    }
  }
})

export default quickLanguageStore